
import { Vue } from "vue-class-component";

export default class Chat extends Vue {}
